import { isSameId } from "../../helpers";
export default function (store, { id, before }) {
    const { rows, rowKey } = store.getState();
    if (!rowKey) {
        return;
    }
    const rowIndex = rows.findIndex(col => isSameId(col.id, id));
    const afterRow = rows[rowIndex + 1]?.id;
    const row = rows.splice(rowIndex, 1)[0];
    if (before) {
        const beforeRowIndex = rows.findIndex(col => isSameId(col.id, before));
        rows.splice(beforeRowIndex, 0, row);
    }
    else {
        rows.push(row);
    }
    store.setState({ rows });
    return () => {
        store.in.exec("move-row", {
            id,
            before: afterRow,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=move.js.map